const PRODUCTION = "production";

/**
 * Footer label for the running build: "v1.0.0" in production,
 * "v1.0.0 Staging" elsewhere. Empty when the build has no version.
 * @param {string|undefined} version package.json version
 * @param {string|undefined} environment ENVIRONMENT of the build
 * @returns {string}
 */
export function appVersionLabel(version, environment) {
  if (!version) return "";

  const env = (environment || "").trim();
  if (!env || env.toLowerCase() === PRODUCTION) return `v${version}`;

  return `v${version} ${env.charAt(0).toUpperCase()}${env.slice(1).toLowerCase()}`;
}
